"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M9.5 10a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M7.5 4A1.5 1.5 0 0 0 6 5.5V9h-.5A1.5 1.5 0 0 0 4 10.5v7A1.5 1.5 0 0 0 5.5 19h13a1.5 1.5 0 0 0 1.5-1.5V11a1.5 1.5 0 0 0-1.5-1.5H18v-1a.5.5 0 0 0-.146-.354l-4-4A.5.5 0 0 0 13.5 4zM7 5.5a.5.5 0 0 1 .5-.5H13v2.5A1.5 1.5 0 0 0 14.5 9H17v1.5a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 7 10.5zM16.293 8H14.5a.5.5 0 0 1-.5-.5V5.707zM5.5 10H6v.5A2.5 2.5 0 0 0 8.5 13h7a2.5 2.5 0 0 0 2.5-2.5h.5a.5.5 0 0 1 .5.5v6.5a.5.5 0 0 1-.5.5H18v-.5a2.5 2.5 0 0 0-2.5-2.5h-7A2.5 2.5 0 0 0 6 17.5v.5h-.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5M17 17.5v.5H7v-.5A1.5 1.5 0 0 1 8.5 16h7a1.5 1.5 0 0 1 1.5 1.5"
  })]
}), 'Printer');
